import { CoreModel } from '../../models/core/core.model';
/**
 * Charts color scheme definition
 */
export class ChartsColorScheme {
  domain: string[];
}

function ChartsColorScheme_tsickle_Closure_declarations() {
/** @type {?} */
ChartsColorScheme.prototype.domain;
}

/**
 * Chart model definition
 */
export class ChartModel extends CoreModel {
/**
 * Data to show
 */
data: any[];
/**
 * Dimensions of chart [width, height] by px
 */
view?: number[];
/**
 * Fill elements with a gradient instead of a solid color. Default: false.
 */
gradient?: boolean;
/**
 * If to show the legend. Default: true.
 */
showLegend?: boolean;
/**
 * Legend position. Can be: top, right, bottom, center. Default: right.
 */
legendPosition?: string;
/**
 * Chart alignment. Can be: start, center, end. Default: start.
 */
chartAlignment?: string;
/**
 * Array with string css color values. Default: [].
 */
colorScheme?: ChartsColorScheme;
/**
 * Name of current scheme. Default: forest.
 * All are: air, aqua, cool, fire, flame, forest, horizon, natural, neons, night, nightLights, ocean, picnic, solar, vivid.
 */
colorSchemeName?: string;
/**
 * If to show the x axis. Default: true.
 */
showXAxis?: boolean;
/**
 * If to show the y axis. Default: true.
 */
showYAxis?: boolean;
/**
 * If to show the x axis label. Default: true.
 */
showXAxisLabel?: boolean;
/**
 * If to show the y axis label. Default: true.
 */
showYAxisLabel?: boolean;
/**
 * The x axis label
 */
xAxisLabel?: string;
/**
 * The y axis label
 */
yAxisLabel?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ChartModel_tsickle_Closure_declarations() {
/**
 * Data to show
 * @type {?}
 */
ChartModel.prototype.data;
/**
 * Dimensions of chart [width, height] by px
 * @type {?}
 */
ChartModel.prototype.view;
/**
 * Fill elements with a gradient instead of a solid color. Default: false.
 * @type {?}
 */
ChartModel.prototype.gradient;
/**
 * If to show the legend. Default: true.
 * @type {?}
 */
ChartModel.prototype.showLegend;
/**
 * Legend position. Can be: top, right, bottom, center. Default: right.
 * @type {?}
 */
ChartModel.prototype.legendPosition;
/**
 * Chart alignment. Can be: start, center, end. Default: start.
 * @type {?}
 */
ChartModel.prototype.chartAlignment;
/**
 * Array with string css color values. Default: [].
 * @type {?}
 */
ChartModel.prototype.colorScheme;
/**
 * Name of current scheme. Default: forest.
 * All are: air, aqua, cool, fire, flame, forest, horizon, natural, neons, night, nightLights, ocean, picnic, solar, vivid.
 * @type {?}
 */
ChartModel.prototype.colorSchemeName;
/**
 * If to show the x axis. Default: true.
 * @type {?}
 */
ChartModel.prototype.showXAxis;
/**
 * If to show the y axis. Default: true.
 * @type {?}
 */
ChartModel.prototype.showYAxis;
/**
 * If to show the x axis label. Default: true.
 * @type {?}
 */
ChartModel.prototype.showXAxisLabel;
/**
 * If to show the y axis label. Default: true.
 * @type {?}
 */
ChartModel.prototype.showYAxisLabel;
/**
 * The x axis label
 * @type {?}
 */
ChartModel.prototype.xAxisLabel;
/**
 * The y axis label
 * @type {?}
 */
ChartModel.prototype.yAxisLabel;
}

